module.exports = __webpack_public_path__ + "static/media/promo_intro_4.de9a09da.png";